import http, { handleApiResponse } from "@/services/http";
import ApiResponse from "@/models/ApiResponse";
import {
  StoreInOutBookResult,
  StoreInOutPreAccError,
  StoreInOutPreAccLookups,
  StoreInOutPreAccRef,
  StoreInOutReAccountResult,
  StoreInOutSetStatusResult,
  StoreInOutStatusRef,
  StoreInOutTakeBackResult,
} from "../models/StoreInOutPreAccounting";

export default class StoreInOutPreAccountingApi {
  // Böngésző lookupok (kontír-státuszok, periódusok, is_book)
  static getLookups(): Promise<StoreInOutPreAccLookups> {
    return http
      .get<ApiResponse<StoreInOutPreAccLookups>>(`store-in-out-pre-accounting/lookups`)
      .then(handleApiResponse);
  }

  // A kijelölt be/kitárolások csoportos (újra)kontírozása (K2D pb_cont 3-as ág →
  // spp_mix_cont / KÉK-nél spp_postcalc_price_cont); bizonylatonként külön tranzakció
  // fut, a hibák a failures listában jönnek vissza. A K2D a grid AKTUÁLIS
  // acc_group / acc_event / note értékeit adja az SP-nek, ezért a teljes sor utazik.
  static reAccount(docs: StoreInOutPreAccRef[]): Promise<StoreInOutReAccountResult> {
    return http
      .post<ApiResponse<StoreInOutReAccountResult>>(`store-in-out-pre-accounting/re-account`, {
        docs: docs.map((x) => ({
          storeIn: x.storeIn,
          gStoreIn: x.gStoreIn,
          storeOut: x.storeOut,
          period: x.period,
          parts: x.parts,
          stockValueDiff: x.stockValueDiff,
          accGroup: x.accGroup,
          accEvent: x.accEvent,
          note: x.note,
          accStatus: x.accStatus,
        })),
      })
      .then(handleApiResponse);
  }

  //---------- A számla előkontírozás (DLMP476) MIX-kompatibilis végpontjai ----------//
  // A K2D-ben is ugyanaz a sheet-szintű esemény szolgálja ki a be/kitárolás és a
  // számla előkontírozás ablakot (ue_menu_acc_status_csoportos), ezért a státusz-
  // műveletek és a hibanapló a meglévő végpontokra mennek, 'MIX' prefixszel.

  // Egy MIX bizonylat kontírozási hibalistája (K2D pb_err → mmaccinvserr, prefix 'MIX')
  static getErrors(mixId: number): Promise<StoreInOutPreAccError[]> {
    return http
      .get<ApiResponse<StoreInOutPreAccError[]>>(`pre-accounting-invoices/MIX/${mixId}/errors`)
      .then(handleApiResponse);
  }

  // Csoportos kontír státusz állítás (K2D "Státusz állítás" menü — Még nem adható fel = 2,
  // Feladható = 3, Feladásra előkészítve = 5, Nem feladandó = 9). Bizonylatonként külön
  // tranzakció fut; a hibás sorok a failures listában jönnek vissza.
  static setStatuses(
    status: number,
    invoices: StoreInOutStatusRef[]
  ): Promise<StoreInOutSetStatusResult> {
    return http
      .post<ApiResponse<StoreInOutSetStatusResult>>(
        `pre-accounting-invoices/set-status/${status}`,
        { invoices }
      )
      .then(handleApiResponse);
  }

  // Csoportos "Feladva": a kijelölt MIX bizonylatok feladása a belső főkönyvbe
  // (K2D m_feladva → spnaccinvsbooking). allowAutoPromote = az "egyből feladva"
  // jogosultság — a nem Feladható státuszúakra előbb lefut a Feladható-ág.
  static book(
    invoices: StoreInOutStatusRef[],
    allowAutoPromote: boolean
  ): Promise<StoreInOutBookResult> {
    return http
      .post<ApiResponse<StoreInOutBookResult>>(`pre-accounting-invoices/book`, {
        invoices,
        allowAutoPromote,
      })
      .then(handleApiResponse);
  }

  // Csoportos "Feladvából feladhatóba" — visszavétel a főkönyvből
  // (K2D m_feladvabol → spjbookhanding_del). confirmed=false-szal a nyitott
  // ÁFA bevallás kérdés jöhet vissza (needsConfirmation).
  static takeBack(
    invoices: StoreInOutStatusRef[],
    confirmed: boolean
  ): Promise<StoreInOutTakeBackResult> {
    return http
      .post<ApiResponse<StoreInOutTakeBackResult>>(`pre-accounting-invoices/take-back`, {
        invoices,
        confirmed,
      })
      .then(handleApiResponse);
  }
}
